<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="paymentHistory_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="paymentHistory_export_button" @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      show-footer
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="220"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isPayAdvance"
          title="支付类型"
          min-width="130"
          sortable
          :formatter="
            ({ cellValue }) => formatterAdvance({ cellValue }, 'isPayAdvance')
          "
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isPayAdvance"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in payAdvanceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="actualAmount"
          title="实际承运人实收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.actualAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.actualAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payStatus"
          title="支付状态"
          min-width="190"
          sortable
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payStatus')
          "
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.payStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="流水单号"
          min-width="264"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="请输入流水单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settlementType"
          title="结算类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'settlementType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.settlementType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.settlementTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="orderDetailDriverName"
          title="承运人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailDriverName"
            placeholder="请输入承运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入车队"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadQuantity"
          title="装货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="partyType != 'DRIVER' && partyType != 'DRIVER_LEADER'"
      >
        <vxe-table-column
          field="price"
          title="托运人成交单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.priceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.priceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="partyType != 'SHIPMENT' && partyType != 'SHIPMENT_COMPANY'"
      >
        <vxe-table-column
          field="realPrice"
          title="实际承运人承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.realPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.realPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="里程数(公里)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="false">
        <vxe-table-column
          field="shipmentActualFreight"
          title="托运人实付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <!-- <vxe-table-column>
        <vxe-table-column field="payOil" title="平台预付油点(元)" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.payOilStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.payOilEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="payAmount"
          title="平台预付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column field="allotOil" title="已分配油费(元)" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.allotOilStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.allotOilEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderGmtCreated"
          title="下单时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.orderGmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'orderGmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="detailGmtCreated"
          title="接单时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.detailGmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'detailGmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="截止装车时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装车时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="截止卸车时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="signTime"
          title="卸货时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settleTime"
          title="核算时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.settleTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'settleTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="loginkTarget === '1'">
        <vxe-table-column
          field="paymentFinishTime"
          title="支付完成时间"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.paymentFinishTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'paymentFinishTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="remark"
          title="失败原因"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.remark"
            placeholder="请输入失败原因"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="60px" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              paymentHistory_receiptElectroni_button &&
                scope.row.payStatus == 1 &&
                (scope.row.payType != 1 && scope.row.payType != 2)
            "
            class="item"
            effect="dark"
            content="查看电子回单"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funreceiptElectroni(scope.row.code, scope.row)"
            >
              <i class="el-icon-paperclip" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <el-dialog
      :visible.sync="showElectronicReceiptFlag"
      :modal="false"
      width="600px"
      height="600px"
    >
      <img width="100%" :src="showElectronicReceiptUrl" />
    </el-dialog>
    <!-- 错误信息 -->
    <el-dialog
      title="失败信息"
      :visible.sync="dialogTableVisible"
      class="abow_dialog"
    >
      <el-table :data="errorData" height="100%" border>
        <el-table-column property="code" label="订单号" width="290" />
        <el-table-column property="msg" label="错误描述" width="300" />
      </el-table>
    </el-dialog>
    <downloadData ref="downloadRef" />
    <vxe-modal
      v-model="modelDetailFlag"
      width="1200"
      height="80%"
      title="回单详情"
      resize
      :transfer="true"
    >
      <MultifilePreview
        v-if="modelDetailFlag"
        :pdfUrls="pdfUrls"
      ></MultifilePreview>
    </vxe-modal>
  </div>
</template>
<script>
import MultifilePreview from "@/components/MultifilePreview/index.vue";
import { remitDefinite } from "@/api/transport";
import { electronicReceipt } from "@/api/InternetBanking";
import { getLimit } from "@/utils/getLimit.js";
export default {
  name: "PaymentHistory",
  components: {
    MultifilePreview
  },
  data() {
    return {
      modelDetailFlag: false,
      exportObj: {
        exportUrl:
          "/ntocc-tms-api/remitDefinite/exportRemitDefiniteRecord4Excel", //导出接口
        name: "打款记录"
      },
      partyType: this.$store.getters.party.partyType,
      callbackTimeRange: "",
      loading: false,
      tableData: [],
      dialogTableVisible: false,
      ModelCashMoney: false,
      showElectronicReceiptFlag: false,
      paymentHistory_search_button: false, //查询
      paymentHistory_export_button: false, //导出
      paymentHistory_receiptElectroni_button: false, //电子回单
      showElectronicReceiptUrl: "",
      errorData: [],
      parentData: {},
      listQuery: {
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        detailGmtCreatedRange: "",
        orderGmtCreatedRange: "",
        settleTimeRange: "",
        paymentFinishTimeRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        // isPayAdvance: "0",
        payerRole: "0"
      },
      accdata: [],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      sumObject: {},
      loginkTarget: "0",
      pdfUrls: "",
      payAdvanceList: [
        { label: "到付", value: 0 },
        { label: "预付", value: 1 },
        { label: "回单", value: 2 }
      ]
    };
  },
  created() {
    this.parentData.settlementTypeOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.parentData.payStatusOptions = [
      { label: "处理中", value: 0 },
      { label: "支付成功", value: 1 },
      { label: "支付失败", value: 2 }
    ];
    this.parentData.payTypeOptions = [
      { label: "油点", value: 1 },
      { label: "加油", value: 2 },
      { label: "转账支付", value: 3 },
      { label: "余额支付", value: 4 },
      { label: "合并打款", value: 5 },
      { label: "车队分账", value: 6 },
      { label: "凭证支付", value: 9 },
      { label: "银行支付", value: 10 }
    ];
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.loginkTarget = dataBranch.partyGroupConfigCacheMap
      .loginkTarget_reportProvince
      ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince
          .configValue
      : 0;
    this.paymentHistory_search_button = getLimit(
      "paymentHistory_search_button"
    );
    this.paymentHistory_export_button = getLimit(
      "paymentHistory_export_button"
    );
    this.paymentHistory_receiptElectroni_button = getLimit(
      "paymentHistory_receiptElectroni_button"
    );
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        remitDefinite(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.price = item.price + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.unloadQuantity = item.unloadQuantity + item.coalUnitName;
            item.loadQuantity = item.loadQuantity + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    async funreceiptElectroni(code, item) {
      if (!item.payReceiptImg) {
        this.$message({ message: "暂无回单", type: "warning" });
        return;
      }
      this.pdfUrls = item.payReceiptImg;
      this.modelDetailFlag = true;
      // const rLoading = this.openLoading();
      // let response = await electronicReceipt({ code });
      // rLoading.close();
      // let url = response.data;
      // if (url) {
      //   window.open(url, "_blank");
      // } else {
      //   return
      // }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterAdvance({ cellValue }, prefix) {
      const item = this.payAdvanceList.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    hideModel() {
      this.ModelCashMoney = false;
      this.findList();
    },

    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "distance",
              "shipmentActualFreight",
              "driverActualFreight",
              "payOil",
              "payAmount",
              "allotOil"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          return "-";
        })
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
